import { graphql } from 'app/generated/gql'
import { gqlQuery } from 'app/lib/graphqlClient'
import { debug } from 'lib/logging'

const ROLE_NAME_QUERY = graphql(`
  query RoleName($id: ID!) {
    role(id: $id) {
      id
      name
    }
  }
`)

const roleNames: Record<string, Promise<string>> = {}

/** Cached; a deleted role reads as such until the API unassigns its tasks. */
export async function getRoleName(roleId: string) {
  roleNames[roleId] ??= gqlQuery(ROLE_NAME_QUERY, { id: roleId })
    .then(({ data, error }) => {
      if (error) debug(`tasks`, `role(${roleId}) lookup failed`, error)
      return data?.role?.name ?? `Deleted role`
    })
    .catch((err) => {
      debug(`tasks`, `role(${roleId}) lookup threw`, err)
      return `Deleted role`
    })
  return roleNames[roleId]
}
